webpackJsonp([70144966829960],{

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  background: ', ';\n  border: none;\n  display: inline-flex;\n  align-items: center;\n  border-radius: ', ';\n  font-size: ', ';\n  color: white;\n  padding: ', ';\n  transition: all ', ';\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n  &:hover {\n    background: ', ';\n    cursor: pointer;\n    transform: translateY(-2px);\n  }\n  &:focus {\n    outline: none;\n  }\n  svg {\n    width: 20px;\n    height: 20px;\n    margin-right: 0.75rem;\n    fill: white;\n  }\n'], ['\n  background: ', ';\n  border: none;\n  display: inline-flex;\n  align-items: center;\n  border-radius: ', ';\n  font-size: ', ';\n  color: white;\n  padding: ', ';\n  transition: all ', ';\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n  &:hover {\n    background: ', ';\n    cursor: pointer;\n    transform: translateY(-2px);\n  }\n  &:focus {\n    outline: none;\n  }\n  svg {\n    width: 20px;\n    height: 20px;\n    margin-right: 0.75rem;\n    fill: white;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _polished = __webpack_require__(160);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _styledComponents2.default.button(_templateObject, function (props) {
	  return props.theme.primary;
	}, function (props) {
	  return props.big ? '1.5rem' : '1rem';
	}, function (props) {
	  return props.big ? '1.2rem' : '1rem';
	}, function (props) {
	  return props.big ? '0.35rem 1.6rem' : '0.25rem 1.5rem';
	}, function (props) {
	  return props.theme.transitionTime;
	}, function (props) {
	  return (0, _polished.lighten)(0.05, props.theme.primary);
	});
	
	var Button = function Button(props) {
	  return _react2.default.createElement(
	    Wrapper,
	    { big: props.big },
	    props.children
	  );
	};
	
	exports.default = Button;
	module.exports = exports['default'];

/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  grid-column: 2;\n  box-shadow: 0 4px 120px rgba(0, 0, 0, 0.1);\n  border-radius: 1rem;\n  padding: 2rem 4rem;\n  background-color: ', ';\n  z-index: 9000;\n  margin-top: -3rem;\n  @media ', ' {\n    padding: 3rem 3rem;\n  }\n  @media ', ' {\n    padding: 2rem 1.5rem;\n  }\n  form {\n    p {\n      label,\n      input {\n        display: block;\n      }\n      input {\n        min-width: 275px;\n      }\n      textarea {\n        resize: vertical;\n        min-height: 150px;\n        width: 100%;\n      }\n    }\n  }\n'], ['\n  grid-column: 2;\n  box-shadow: 0 4px 120px rgba(0, 0, 0, 0.1);\n  border-radius: 1rem;\n  padding: 2rem 4rem;\n  background-color: ', ';\n  z-index: 9000;\n  margin-top: -3rem;\n  @media ', ' {\n    padding: 3rem 3rem;\n  }\n  @media ', ' {\n    padding: 2rem 1.5rem;\n  }\n  form {\n    p {\n      label,\n      input {\n        display: block;\n      }\n      input {\n        min-width: 275px;\n      }\n      textarea {\n        resize: vertical;\n        min-height: 150px;\n        width: 100%;\n      }\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(39);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(21);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Wrapper = __webpack_require__(41);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	var _Header = __webpack_require__(61);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Button = __webpack_require__(111);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _media = __webpack_require__(18);
	
	var _SiteConfig = __webpack_require__(17);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; } /* eslint jsx-a11y/label-has-for:0 */
	
	var Content = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.theme.bg;
	}, _media.media.tablet, _media.media.phone);
	
	var encode = function encode(data) {
	  return Object.keys(data).map(function (key) {
	    return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
	  }).join('&');
	};
	
	var Contact = function (_React$Component) {
	  _inherits(Contact, _React$Component);
	
	  function Contact(props) {
	    _classCallCheck(this, Contact);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {};
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    return _this;
	  }
	
	  Contact.prototype.handleChange = function handleChange(e) {
	    var _setState;
	
	    this.setState((_setState = {}, _setState[e.target.name] = e.target.value, _setState));
	  };
	
	  Contact.prototype.handleSubmit = function handleSubmit(e) {
	    fetch('/', {
	      method: 'POST',
	      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	      body: encode(_extends({ 'form-name': 'contact' }, this.state))
	    }).then(function () {
	      return (0, _gatsbyLink.navigateTo)('/thanks/');
	    }).catch(function (error) {
	      return alert(error);
	    });
	    e.preventDefault();
	  };
	
	  Contact.prototype.render = function render() {
	    return _react2.default.createElement(
	      _Wrapper2.default,
	      null,
	      _react2.default.createElement(_reactHelmet2.default, { title: 'Contact | ' + _SiteConfig2.default.siteTitle }),
	      _react2.default.createElement(
	        _Header2.default,
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' },
	          _SiteConfig2.default.siteTitle
	        )
	      ),
	      _react2.default.createElement(
	        Content,
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Contact'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _SiteConfig2.default.contactFormTxt
	        ),
	        _react2.default.createElement(
	          'form',
	          {
	            name: 'contact',
	            method: 'post',
	            action: '/thanks/',
	            'data-netlify': 'true',
	            'data-netlify-honeypot': 'bot-field',
	            onSubmit: this.handleSubmit
	          },
	          _react2.default.createElement('input', { type: 'hidden', name: 'bot-field', onChange: this.handleChange }),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'name' },
	              'Name'
	            ),
	            _react2.default.createElement('input', { name: 'name', type: 'text', onChange: this.handleChange, required: true })
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'email' },
	              'E-Mail'
	            ),
	            _react2.default.createElement('input', { name: 'email', type: 'email', onChange: this.handleChange, required: true })
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'message' },
	              'Your Message'
	            ),
	            _react2.default.createElement('textarea', { name: 'message', onChange: this.handleChange, required: true })
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              _Button2.default,
	              { type: 'submit' },
	              'Send'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Contact;
	}(_react2.default.Component);
	
	exports.default = Contact;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-291abcb60044403f1afd.js